import { Service } from '@tino-frontend/adapters'
import { ContentFAQ, ContentResponse, FAQType } from '@types'

export class ContentService {
  constructor(private readonly http: Service) {
    this.http = http
  }

  getFAQ(type: FAQType): Promise<ContentResponse<ContentFAQ>> {
    return this.http.get<unknown, ContentResponse<ContentFAQ>>(
      `/api/content/faq/${type}.json`
    )
  }

  async getLocalFAQ(type: FAQType): Promise<any> {
    const faq = await fetch(`/faq/${type}.json`)
    return await faq.json()
  }
}
